import {Box,Typography,Button, CircularProgress, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio} from "@mui/material"
import MultiInput from "./MultiInput"
import EditorText from "./EditorText"

const QuestionView = ({content,title,currentQuestion,totalQuestions,subTime,time,setMessage,message,handleSend,questions,count,submitting})=>{
    
    return (
        <Box style={{width:450}}>
            <Box display="flex" flexDirection="row" justifyContent="space-between" m={1} alignItems="center" width="80%">
                <Typography style={{color:'white'}}>
                    {title}
                </Typography>
                <Typography pl={2} style={{color:"gold",fontSize:13,width:200}}>
                    {time}
                </Typography> 
            </Box>
            <Typography m={1} style={{color:"gold",fontSize:13,width:200}}>
                {subTime}
            </Typography> 
            <Typography m={1} style={{color:"gold",fontSize:15,width:200}}>
                {currentQuestion}/{totalQuestions}
            </Typography> 
            <Box sx={{justifyContent:"flex-start",alignItems:"flex-start",margin:1}}>
                {
                    questions == count ?
                        <Typography sx={{fontSize:13,padding:1,whiteSpace:"pre-wrap"}}>
                            We thank you for taking this assessment, we hope you did well, view your score now on your DASHBOARD
                        </Typography>
                    :
                    <Box width="100%">
                        <Typography sx={{fontFamily:"dinofans",fontSize:13,pb:1}}>
                           Question
                        </Typography>
                        <Typography sx={{fontSize:13,padding:1,whiteSpace:"pre-wrap"}}>
                           {content?.question}
                        </Typography>
                        {(content?.choices?.length > 0 && (content?.type.includes("selection") || content?.type.includes("true") || content?.type.includes("false")) ) && (
                            <Box justifyContent="center" alignItems="center" width="80%" mt={2} mb={2}>
                                <FormControl >
                                    <FormLabel sx={{fontFamily:"dinofans",fontSize:13,color:"#fff", mb:1}} id="demo-row-radio-buttons-group-label">Choose :</FormLabel>
                                        <RadioGroup
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group"
                                            sx={{ml:2}}
                                            value={message}
                                        >
                                            {content?.choices?.map((item,index)=>(
                                                    <FormControlLabel key={index}  value={item} control={<Radio sx={{fontSize:11,color:"#ff0"}} onClick={()=>{
                                                        setMessage(item)
                                                    }} />} label={<Typography sx={{fontSize:12,m:1}}>{item}</Typography>}/>
                                                
                                                ))
                                            }
                                        </RadioGroup>                        
                                </FormControl>
                            </Box> 
                        )

                        }
                    </Box>
                } 
                {(questions !== count && content?.type.includes("open")) && (
                    <Box justifyContent="center" alignItems="center" width="80%" mt={2} mb={2}>
                        <EditorText
                            data={message}
                            setData={setMessage}
                            width="95%"
                            label="answer"
                            isRequired={true}
                        />
                    </Box>
                   )
                }
                <Button onClick={async (e)=>{
                    e?.preventDefault()
                    await handleSend()
                }} disabled={submitting} sx={{backgroundColor:"gold",color:"black",marginLeft:1,marginRight:{xs:0,md:5},fontSize:{xs:10,md:12},height:40,width:{xs:120,md:200},fontFamily:"dinofans"}} variant="contained">
                    {
                        submitting ? 
                            <CircularProgress size={20} sx={{color:"#fff"}}/>
                        : 

                        (questions == count ? "close" : "Send")
                    }
                </Button>
            </Box>
        </Box>
    )	
}


export default QuestionView


